import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IPostBody } from 'src/types/PostBody';
import { ViewVariance } from 'src/types/ViewVariance';
import axiosInstance from 'src/utils/axios';
import { convertDate } from 'src/utils/transformation';

interface VarianceRequest {
  companyId?: string;
  body?: IPostBody;
}

interface VarianceResponse {
  totalRecords: number;
  items: ViewVariance[];
}

const useVarianceApi = () => {
  const call = useCallback(
    ({ companyId, body }: VarianceRequest = {}) =>
      new Promise<VarianceResponse>((resolve, reject) => {
        axiosInstance
          .post<VarianceResponse>(api.getVariance(companyId || ''), body)
          .then((data) => {
            const formatData = data.data.items.map((item) => ({
              ...item,
              poDate: convertDate(item.poDate),
              varianceQuantityPercentage: item.varianceQuantityPercentage || 0,
            }));
            const res = { items: formatData, totalRecords: data.data.totalRecords };
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading, value, setValue } = useAsync(
    call,
    false,
    undefined,
    {} as VarianceResponse
  );

  return {
    getVarianceList: execute,
    varianceList: value,
    setVarianceList: setValue,
    isVarianceLoading: isLoading,
  };
};

export default useVarianceApi;
